import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData, logout, login } from 'src/redux/actions/accountActions';
import oldAuthService from 'src/utils/oldAuthService';

function Auth({ children }) {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const initAuth = async () => {
      oldAuthService.setAxiosInterceptors({
        onLogout: () => dispatch(logout())
      });

      oldAuthService.handleAuthentication();

      if (oldAuthService.isAuthenticated()) {
        const user = await oldAuthService.loginInWithToken();

        await dispatch(setUserData(user));
      } else {
        await dispatch(login());
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return children;
}

Auth.propTypes = {
  children: PropTypes.any
};

export default Auth;
